module.exports = __webpack_public_path__ + "assets/images/logo.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.png
 ** module id = 22
 ** module chunks = 0
 **/